import { ISelector, TApiEntity } from '@src/models/api';
import { NG_SELECTOR } from './ngSelector';

type TQuery = { [x: string]: string | undefined };

const addQueryToUrl = (url: URL, q?: TQuery, clearEmptyParams?: boolean | undefined): URL => {
  if (!q) {
    return url;
  }

  const queryArray = Object.entries(q);

  if (queryArray.length === 0) {
    return url;
  }

  for (let i = 0; i < queryArray.length; i++) {
    const [name, value] = queryArray[i];
    const condition = typeof value === 'string' && (value || (!clearEmptyParams && value === ''));
    if (condition) {
      url.searchParams.set(name, value);
    }
  }

  return url;
};

interface IPathParams {
  /** Базовый путь, чаще всего содержит имя бандла */
  path?: string;
  /** Сущность */
  entity?: TApiEntity;
  /** Id сущности */
  id?: string | number;
  /** Query параметры */
  query?: TQuery;
  /** Хеш */
  hash?: string;
  /** Селектор для параметров ngApi */
  selector?: ISelector;
}

/**
 * Функция для получения внутреннего path по параметрам
 * В основу лежит принципы построения путей в приложении
 * @link https://centraai.atlassian.net/wiki/spaces/CEN/pages/2447900673/in+progress+Lego
 */
export const getPath = ({ path, entity, query, id, hash, selector }: IPathParams, clearEmptyParams = false): string => {
  const fakeOrigin = 'http://localhost';
  let stringUrl = fakeOrigin;
  stringUrl = path ? stringUrl + (path[0] === '/' ? path : '/' + path) : stringUrl;
  stringUrl = entity ? stringUrl + '/' + entity : stringUrl;
  stringUrl = id ? stringUrl + '/' + id : stringUrl;

  let baseUrl = new URL(stringUrl);
  baseUrl = addQueryToUrl(baseUrl, query, clearEmptyParams);

  if (selector) {
    const urlParams = NG_SELECTOR.formatToUrlParams(selector);

    baseUrl = addQueryToUrl(baseUrl, urlParams as TQuery, clearEmptyParams);
  }

  if (hash) {
    const newHash = hash[0] === '#' ? hash : `#${hash}`;
    baseUrl = new URL(newHash, baseUrl);
  }

  return baseUrl.toString().replace(fakeOrigin, '');
};

export const getQuery = (): null | { [x: string]: string } => {
  if (typeof window === 'undefined') return null;

  const { href } = location;
  const [, queries] = href.split('?');

  if (!queries) return null;

  const result = {};
  const queriesList = queries.split('&');
  queriesList.forEach((q) => {
    const [key, value] = q.split('=');
    if (key && value) {
      result[key] = value;
    }
  });

  return result;
};
